import { render } from "./custom-budget-breakdown.vue?vue&type=template&id=ca2d6ade&ts=true"
import script from "./custom-budget-breakdown.ts?vue&type=script&lang=ts&external"
export * from "./custom-budget-breakdown.ts?vue&type=script&lang=ts&external"

import "./custom-budget-breakdown.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__